import React, { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { AnimatePresence, motion } from 'framer-motion';

import {
  setShowHeader,
  setTitle,
  setShowBack,
  setShowMenu,
  setShowBackBlack
} from "shared/store/headerSlice";
import LoginPage from "features/auth/presentation/LoginPage";
import ResetPasswordPage from "features/auth/presentation/ResetPasswordPage";
import ParkingStatusPage from "features/parking/presentation/ParkingStatusPage";

import ParkingStatusAdditionalPage from "features/parking/presentation/ParkingStatusAdditionalPage";
import MenuManagerPage from "features/user/presentation/MenuManagerPage";

import Header from "shared/components/Header";
import { setOnBack } from "shared/store/headerSlice";

import ParkingSetting from "features/parking/presentation/ParkingSetting";
import ParkingSpotSettings from "features/parking/presentation/ParkingSpotSettings";
import ParkingCheck from "features/parking/presentation/ParkingCheck";
import ParkingCheckSuccess from "features/parking/presentation/ParkingCheckSuccess";
import ParkingPayment from "features/parking/presentation/ParkingPayment";
import ParkingSettingOfManager from "features/parking/presentation/ParkingSettingOfManager";
import ParkingFormAdd from "features/parking/presentation/ParkingFormAdd";
import UserWorkingTime from "features/user/presentation/UserWorkingTime";
import ScheduleManagementPage from "features/scheduleManagement/presentation/ScheduleManagementPage";
import ScheduleSetting from "features/scheduleManagement/presentation/ScheduleSetting";
import ScheduleCalendar from "features/scheduleManagement/presentation/ScheduleCalendar";
import DailySchedule from "features/scheduleManagement/presentation/DailySchedule";
import ParkingPaymentComplete from "features/parking/presentation/ParkingPaymentComplete";
import ParkingUnpaidList from "features/parking/presentation/ParkingUnpaidList";
import ParkingUnpaidDetail from "features/parking/presentation/ParkingUnpaidDetail";
import PakingCalendarPage from "features/parking/presentation/PakingCalendarPage";
import PakingCalendarDetailPage from "features/parking/presentation/PakingCalendarDetailPage";
import UserManager from "features/user/presentation/UserManager";
import UserManagerEdit from "features/user/presentation/UserManagerEdit";
import UserAddressManager from "features/user/presentation/UserAddressManager";
import UserAddressManagerEdit from "features/user/presentation/UserAddressManagerEdit";
import PakingAttendancePage from "features/parking/presentation/PakingAttendancePage";
import PakingListAttendancePage from "features/parking/presentation/PakingListAttendancePage";
import PakingDetailAttendancePage from "features/parking/presentation/PakingDetailAttendancePage";
import PakingSettlementPage from "features/parking/presentation/PakingSettlementPage";
import PakingDetailSettlementPage from "features/parking/presentation/PakingDetailSettlementPage";
import ParkingWorkDayBook from "features/parking/presentation/ParkingWorkDayBook";
import ParkingWorkdayAttendancePage from "features/parking/presentation/ParkingWorkdayAttendancePage";
import ParkingCheckResult from "features/parking/presentation/ParkingCheckResult";
import ParkingPaymentSuccess from "features/parking/presentation/ParkingPaymentSuccess";
import AnimatedRoute from "shared/components/AnimatedRoute";
import ParkingPaymentPending from "features/parking/presentation/ParkingPaymentPending";
import ParkingPaymentEmpty from "features/parking/presentation/ParkingPaymentEmpty";
import ParkingSettingList from "features/parking/presentation/ParkingSettingList";
import ListPage from "../features/user/presentation/ListPage";
import ParkingSetting2 from "../features/parking/presentation/ParkingSetting2";
import ParkingStatusPage2 from "../features/parking/presentation/ParkingStatusPage2";
import ParkingPaymentWaitAddress from "../features/parking/presentation/ParkingPaymentWaitAddress";
import ParkingClosing from "features/parking/presentation/ParkingClosing";
import AppLoading from "../shared/components/AppLoading";
import { getServerTime } from "features/auth/usecases/AuthUsecases";
import { setAlertCheckout } from "../shared/store/headerSlice";
import { setDayType, setServerTime } from "../features/auth/presentation/store/authSlice";
import { DateTime } from "luxon";
import { getFormattedTime } from "../utils/common";
import useAttendanceCheck, { STORAGE_KEYS } from "../hooks/useAttendanceCheck";
import ParkingPaymentMonthly from "../features/parking/presentation/ParkingPaymentMonthly";
// Define route configurations
const routeConfigs = [
  { path: "/", component: LoginPage, title: "", noHeader: true },
  { path: "/list_page", component: ListPage, title: "메뉴", parentRoute: "/menu_manager" },
  { path: "/menu_manager", component: MenuManagerPage, title: "메뉴" },
  { path: "/reset_password", component: ResetPasswordPage, title: "", noHeader: true, parentRoute: "/" },
  { path: "/parking_status", component: ParkingStatusPage, title: "주차 상황판", parentRoute: "/menu_manager" },
  { path: "/parking_closing", component: ParkingClosing, title: "일마감", parentRoute: "/menu_manager" },
  { path: "/parking_status2", component: ParkingStatusPage2, title: "주차 상황판", parentRoute: "/menu_manager" },
  { path: "/parking_calendar", component: PakingCalendarPage, title: "스케줄 관리", parentRoute: "/menu_manager" },
  { path: "/parking_detail_calendar", component: PakingCalendarDetailPage, title: "스케줄 관리", parentRoute: "/menu_manager" },
  { path: "/parking_attendance", component: PakingAttendancePage, title: "출근기록부", parentRoute: "/menu_manager" },
  { path: "/parking_detail_attendance", component: PakingDetailAttendancePage, title: "출근기록부", parentRoute: "/parking_attendance" },
  { path: "/parking_list_attendance", component: PakingListAttendancePage, title: "출근기록부", parentRoute: "/menu_manager" },
  { path: "/parking_settlement", component: PakingSettlementPage, title: "정산관리", parentRoute: "/menu_manager" },
  { path: "/parking_detail_settlement", component: PakingDetailSettlementPage, title: "정산관리", parentRoute: "/menu_manager" },
  { path: "/parking_workday_book", component: ParkingWorkDayBook, title: "출퇴근기록부", parentRoute: "/menu_manager" },
  { path: "/parking_workday_attendance", component: ParkingWorkdayAttendancePage, title: "출근기록부", parentRoute: "/menu_manager" },
  { path: "/parking_setting", component: ParkingSetting, title: "주차장 설정", parentRoute: "/parking_status" },
  { path: "/parking_setting2", component: ParkingSetting2, title: "주차장 설정" },
  { path: "/parking_setting_manager", component: ParkingSettingOfManager, title: "주차장 설정", parentRoute: "/menu_manager" },
  { path: "/parking_add_form", component: ParkingFormAdd, title: "주차장 설정", parentRoute: "/parking_setting_list" },
  { path: "/parking_spot_setting", component: ParkingSpotSettings, title: "주차장 설정", parentRoute: "/parking_setting" },
  { path: "/parking_status_additional", component: ParkingStatusAdditionalPage, title: "주차 상황판", parentRoute: "/parking_setting" },
  { path: "/parking_check", component: ParkingCheck, title: "입차", parentRoute: "/parking_status" },
  { path: "/parking_check_success", component: ParkingCheckSuccess, title: "입출차관리", parentRoute: "/parking_status" },
  { path: "/parking_check_result", component: ParkingCheckResult, title: "입차완료" },
  { path: "/parking_payment", component: ParkingPayment, title: "출차", parentRoute: "/parking_check_success" },
  { path: "/parking_payment_complete", component: ParkingPaymentComplete, title: "출차완료", parentRoute: "/parking_payment" },
  { path: "/parking_payment_pending", component: ParkingPaymentPending, title: "출차완료", parentRoute: "/parking_payment" },
  { path: "/parking_payment_success", component: ParkingPaymentSuccess, title: "출차완료" },
  { path: "/parking_unpaid_list", component: ParkingUnpaidList, title: "미납관리", parentRoute: "/menu_manager" },
  { path: "/parking_unpaid_detail", component: ParkingUnpaidDetail, title: "미납관리", parentRoute: "/parking_unpaid_list" },
  { path: "/parking_payment_wait_address", component: ParkingPaymentWaitAddress, title: "미납관리", parentRoute: "/parking_unpaid_list" },
  { path: "/parking_payment_empty", component: ParkingPaymentEmpty, title: "미납관리", parentRoute: "/parking_payment" },
  { path: "/parking_setting_list", component: ParkingSettingList, title: "주차장 설정", parentRoute: "/menu_manager" },
  { path: "/time_attendance", component: UserWorkingTime, title: "출퇴근", parentRoute: "/menu_manager" },
  { path: "/schedule_management", component: ScheduleManagementPage, title: "스케줄관리", parentRoute: "/menu_manager" },
  { path: "/schedule_setting", component: ScheduleSetting, title: "스케줄관리", parentRoute: "/schedule_management" },
  { path: "/schedule_calendar", component: ScheduleCalendar, title: "스케줄관리", parentRoute: "/schedule_management" },
  { path: "/daily_schedule", component: DailySchedule, title: "스케줄관리", parentRoute: "/schedule_calendar" },
  { path: "/user_address_manager", component: UserAddressManager, title: "사용자관리", parentRoute: "/menu_manager" },
  { path: "/user_address_manager_edit", component: UserAddressManagerEdit, title: "사용자관리", parentRoute: "/user_address_manager" },
  { path: "/user_manager", component: UserManager, title: "사용자관리", parentRoute: "/menu_manager" },
  { path: "/user_manager_edit", component: UserManagerEdit, title: "사용자관리", parentRoute: "/menu_manager" },
  { path: "/parking_payment_monthly", component: ParkingPaymentMonthly, title: "정기권결제", parentRoute: "/menu_manager" },
];

export const AppRoutes = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showHeader, appLoading } = useSelector((state) => state.header);
  const { user, serverTime, logedIn, dayType } = useSelector((state) => state.auth);

  // useAttendanceCheck(user, serverTime, logedIn, navigate, dispatch, dayType);
  const isTimePassed = (timeStr) => {
    if (typeof serverTime?.toISO == 'function') {
      const now = new Date(serverTime?.toISO() || new Date().toISOString());
      const currentHours = now.getHours();
      const currentMinutes = now.getMinutes();

      const [targetHours, targetMinutes] = timeStr?.split(':').map(Number);

      if (currentHours > targetHours) {
        return true;
      } else if (currentHours === targetHours && currentMinutes >= targetMinutes) {
        return true;
      }
      return false;
    } else {
      return false;
    }

  }
  const isValidDateTime = (date) => date !== 'Invalid DateTime';

  const clearLocalStorageAndNavigate = (navigate) => {
    [STORAGE_KEYS.CHECKIN_TIME, STORAGE_KEYS.CHECKOUT_TIME, STORAGE_KEYS.ATTENDANCE_NOTE, STORAGE_KEYS.LEAVE_WORK_NOTE].forEach(item =>
      localStorage.removeItem(item)
    );
    navigate('/time_attendance', { replace: true });
  };

  const checkWorkingHours = (user, serverTime, checkinTime, checkoutTime, dispatch) => {
    const serverDate = getFormattedTime(serverTime, 'yyyy-MM-dd');
    const checkinDate = checkinTime?.split(' ')[0];

    if (!isValidDateTime(serverDate)) return;

    if (checkinDate !== serverDate) {
      clearLocalStorageAndNavigate(navigate);
      return;
    }

    const [workingEndHour, workingEndMinute] = user?.parking?.weekdayOperatingHours
      ?.split('~')[1]
      ?.trim()
      ?.split(':') || [];

    const isPassed = isTimePassed(`${workingEndHour}:${workingEndMinute}`) ||
      (checkinDate !== serverDate && checkoutTime !== null);
    dispatch(setAlertCheckout(isPassed));
  };

  const checkTime = async () => {
    try {
      const checkinTime = localStorage.getItem(STORAGE_KEYS.CHECKIN_TIME);
      const checkoutTime = localStorage.getItem(STORAGE_KEYS.CHECKOUT_TIME);


      const getServerTimeApi = await getServerTime();
      const serverTime = DateTime.fromISO(
        getServerTimeApi?.ISO || DateTime.now().setZone('Asia/Seoul').toISO(),
        { setZone: true }
      );
      dispatch(setServerTime(serverTime.isValid ? serverTime : DateTime.now().setZone('Asia/Seoul')));
      dispatch(setDayType(getServerTimeApi?.dayType || 'WEEKDAY'));

      if (checkinTime) {
        checkWorkingHours(user, serverTime, checkinTime, checkoutTime, dispatch);
      }

      if (!checkinTime && user?.userId) {
        navigate('/time_attendance', { replace: true });
        return;
      }
    } catch (error) {
      console.error('Error checking time:', error);
    }
  };

  useEffect(() => {
    let intervalId;

    checkTime();
    intervalId = setInterval(checkTime, 3000000); // 10 minutes

    return () => clearInterval(intervalId);
  }, [logedIn]);

  useEffect(() => {
    let timeoutId;
    if (serverTime) {
      timeoutId = setTimeout(() => {
        const updatedServerTime = typeof serverTime?.plus === 'function'
          ? serverTime.plus({ seconds: 60 })
          : DateTime.now().setZone('Asia/Seoul');

        dispatch(setServerTime(updatedServerTime));

        const checkinTime = localStorage.getItem(STORAGE_KEYS.CHECKIN_TIME);
        const checkoutTime = localStorage.getItem(STORAGE_KEYS.CHECKOUT_TIME);

        if (checkinTime) {
          checkWorkingHours(user, updatedServerTime, checkinTime, checkoutTime, dispatch);
        } else if (user?.userId) {
          navigate('/time_attendance', { replace: true });
        }
      }, 60000); // 1 minute
    }
    return () => clearTimeout(timeoutId);
  }, [serverTime]);

  // Effect to update the title and display the header
  useEffect(() => {
    const currentRoute = routeConfigs.find((config) => config.path === location.pathname);
    if (currentRoute) {
      dispatch(setTitle(currentRoute.title));
      dispatch(setShowHeader(!currentRoute.noHeader));
    } else {
      dispatch(setTitle(""));
      dispatch(setShowHeader(true));
    }
  }, [location, dispatch]);

  // Effect to process logic back and menu
  useEffect(() => {
    const currentRoute = routeConfigs.find((config) => config.path === location.pathname);
    if (currentRoute && currentRoute.parentRoute) {
      dispatch(setShowBack(true));
      dispatch(setShowMenu(true));
      dispatch(setOnBack(() => navigate(currentRoute.parentRoute)));

      if (location.pathname === "/reset_password") {
        dispatch(setShowBackBlack(true));
      } else {
        dispatch(setShowBackBlack(null));
      }

      if (location.pathname === "/time_attendance") {
        const savedCheckinTime = localStorage.getItem("checkinTime");
        if (savedCheckinTime) {
          dispatch(setShowBack(true));
          dispatch(setShowMenu(true));
        } else {
          dispatch(setShowBack(false));
          dispatch(setShowMenu(false));
        }
      }
    } else {
      dispatch(setShowBack(false));
      dispatch(setShowBackBlack(null));
      dispatch(setShowMenu(false));
    }
  }, [location, dispatch, navigate]);

  useEffect(() => {
    document.addEventListener('message', (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.action === 'goBack') {
          // Logic to open menu or perform action
          // Check if current location.pathname matches any path in routeConfigs
          let currentRoute = routeConfigs.find(config => config.path === location.pathname);
          // console.log(currentRoute);
          if (currentRoute && currentRoute?.parentRoute) {
            const checkinTime = localStorage.getItem("checkinTime");
            if (checkinTime) {
              navigate(currentRoute?.parentRoute)
            }
            // Example: dispatch(setShowMenu(true));
          } else if (!currentRoute) {
            navigate('/menu_manager')
          }
        }
      } catch (error) {
        console.error('Error parsing WebView message:', error);
      }
    });

    return () => {
      document.removeEventListener('message', () => { });
    };
  }, [navigate]);

  return (
    <div className="app-content">
      {showHeader && <Header />}
      {appLoading && <AppLoading />}
      <div className={`main-content ${showHeader ? "" : "pt-0"}`}>
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            {routeConfigs.map(({ path, component: Component }) => (
              <Route
                key={path}
                path={path}
                element={<AnimatedRoute><Component /></AnimatedRoute>}
              />
            ))}
          </Routes>
        </AnimatePresence>
      </div>
    </div>
  );
};
